import axiosLimiter from '@/api/RateLimiter';

export default {
    createDeviceReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "device-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },    
    createReadingReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "reading-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },    
    createPropertyReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "property-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },   
    createBillingReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "billing-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(options) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },
    createMeteringReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "metering-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },   
    createIotDeviceReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "iotdevice-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },       
    createConsumptionReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "consumption-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },  
    createConsumptionTrendReport(recipients: string[], columns: string[], filters: any, options={}, cc=[], bcc=[], description="", fileNote=""): Promise<any> {
        const body = {
            "data": {
                "type": "consumption-trend-report",
                "attributes": {
                    "filters": filters,
                    "columns": columns,
                    "recipients": recipients
                }
            }
        } as any;

        if(Object.keys.length > 0) {
            body.data.attributes.options = options;
        }
        if(cc.length > 0) {
            body.data.attributes.cc = cc;
        }
        if(bcc.length > 0) {
            body.data.attributes.bcc = bcc;
        }
        if(description.length > 0) {
            body.data.attributes.description = description;
        }
        if(fileNote.length > 0) {
            body.data.attributes.fileNote = fileNote;
        }
        return axiosLimiter.post(process.env.VUE_APP_BASCLOUD_SERVER_URL + '/reports', JSON.stringify(body), { headers: { 'Content-Type': 'application/vnd.api+json'}});
    },   
}
  